import { KV } from './../../core/Constant';
import { PlayerEvent } from '../../PlayerEvents';
import Flash from './flash';
import { systemProbe } from '../../utils/util';
import { Promise } from 'es6-promise';
import { removeFromParent } from '../../utils/Dom';
import log from 'loglevel';

/**
 *
 * @export
 * @class FlashPlayer
 * @extends { Flash }
 */
export default class FlashPlayer extends Flash {
  constructor(opt = {}) {
    super(opt);
    this._config = null;
    this.browserType = systemProbe().browser;
    this._store = null;
  }

  initEvents() {}

  emit2All(act, data) {
    this.getOwner() && this.getOwner().emit(act, data);
  }

  setStore(store) {
    this._store = store;
  }

  getStore() {
    return this._store;
  }

  getRoot() {
    return this._root;
  }

  getOwner() {
    return this._owner;
  }

  getDownloadSize() {
    return null;
  }

  // 调度完成和swf就绪完成顺序先后不一,需要在swf就绪后及有属性vjs_setProperty后设置播放源
  setSrc(url) {
    // 暂存url
    this._newUrl = url;
    if (url && this.isReady && this.isFlag) {
      this.setSource(url);
    }
    return Promise.resolve();
  }

  initFlash(config = {}) {
    this._config = config;
    super.initFlash(config);
  }

  destroy() {
    clearInterval(this.timeId);
    this._swf = undefined;
    this._setSrcCount = undefined;
    this._countSwf = undefined;
    this._root = null;
    this.isSetSrc = undefined;
    this.isReady = undefined;
    this._newUrl = '';
    this._oldUrl = '';
    this._src = '';
    this._isLive = false;
    this._isPlaying = false;
    this._store = null;
    this._volume = 0.5;
    this._ended = undefined;
    if (this.flash) {
      removeFromParent(this.flash);
      this.video = null;
      this.flash = null;
    }
  }

  /**
   * 打开或关闭控制条
   * swf本身就不带控制条
   * @param {*} val
   */

  setControls(val) {}

  /**
   * 播放
   */
  play() {
    this._clickPlaying = true;
    if (!this._isLive && this._ended) {
      log.info('点播已播完,重新播放');
      this._ended = false;
      // 点播已播完
      // this.flash.vjs_resume(); // swf内部方法不好使
      this._replay();
    } else {
      if (this.flash.hasOwnProperty('vjs_play')) {
        this.flash.vjs_play();
        this.emit2All(PlayerEvent.TOUCH_PLAY);
      }
    }
  }

  _replay() {
    if (this.flash.hasOwnProperty('vjs_setProperty')) {
      this.flash.vjs_setProperty('currentTime', 0);
      this.flash.vjs_play();
      this.emit2All(PlayerEvent.TOUCH_PLAY);
    }
  }

  /**
   * 暂停
   */
  pause() {
    this._clickPlaying = false;
    if (this.flash.hasOwnProperty('vjs_pause')) {
      this.flash.vjs_pause();
    }
  }

  /**
   * 查看当前视频是否处于暂停状态
   */
  getIsPaused() {
    return this.flash.hasOwnProperty('vjs_getProperty')
      ? this.flash.vjs_getProperty('paused') && this._isPlaying === false
      : true;
  }

  /**
   * 设置自动播放
   * @param {*} value
   */
  setAutoplay(value) {
    if (this.flash.hasOwnProperty('vjs_autoplay')) {
      this.flash.vjs_autoplay(value);
    }
  }

  /**
   * 是否自动播放
   */
  getAutoplay() {
    return this.flash.hasOwnProperty('vjs_getProperty') ? this.flash.vjs_getProperty('autoplay') : null;
  }

  /**
   * 获取当前视频播放的时间，单位：秒
   */
  getCurrentTime() {
    return this.flash.hasOwnProperty('vjs_getProperty') ? this.flash.vjs_getProperty('currentTime') : 0;
  }

  setCurrentTime(t) {
    log.info(`seek(${t})`);
    // 记录seek之前的状态，用于是否派发play事件
    this._beforePlayState = this._isPlaying;
    if (this.flash.hasOwnProperty('vjs_setProperty')) {
      this.flash.vjs_setProperty('currentTime', t);
    }
  }

  /**
   * 获取缓存
   */
  getBuffered() {
    return this.flash.hasOwnProperty('vjs_getProperty') ? this.flash.vjs_getProperty('buffered') : [];
  }

  /**
   * 点播服务中，获取视频的总时长
   */
  getDuration() {
    return this.flash.hasOwnProperty('vjs_getProperty') ? this.flash.vjs_getProperty('duration') : 0;
  }

  /**
   * 是否播放完毕
   */
  getEnded() {
    return this.flash.vjs_getProperty('ended');
  }

  /**
   * 点播服务设置循环播放
   * @param {*} isLoop
   */
  setLoop(isLoop) {
    if (this.flash.hasOwnProperty('vjs_setProperty')) {
      let oldValue = this.flash.vjs_getProperty('loop');
      this.flash.vjs_setProperty('loop', isLoop);
      let newValue = isLoop;
      const e = { oldValue, newValue };
      this.emit2All(PlayerEvent.LOOP_CHANGED, e);
    }
  }

  /***
   * 获取循环状态
   */
  getLoop() {
    return this.flash.vjs_getProperty('loop');
  }

  /**
   * 获取当前视频播放器是否静音
   */
  getMuted() {
    return this.flash.vjs_getProperty('muted');
  }

  /**
   * 设置当前video播放源是否为静音
   * @param {*} isMute
   */
  setMuted(isMute) {
    if (this.flash.hasOwnProperty('vjs_setProperty')) {
      let oldValue = this.flash.vjs_getProperty('muted');
      this.flash.vjs_setProperty('muted', isMute);
      let newValue = isMute;
      const e = { oldValue, newValue };
      this.emit2All(PlayerEvent.MUTED_CHANGED, e);
    }
  }

  /**
   * 获取当前元素网络状态
   */
  getNetworkState() {
    return this.flash.hasOwnProperty('vjs_getProperty') ? this.flash.vjs_getProperty('networkState') : 0;
  }

  /**
   * 获取预加载的数据
   */
  getPreload() {
    return this.flash.vjs_getProperty('preload');
  }

  setPreload(t) {
    if (this.flash.hasOwnProperty('vjs_setProperty')) {
      this.flash.vjs_setProperty('preload', t);
    }
  }

  /**
   * 获取当前视频播放器的准备状态值
   */
  getReadyState() {
    return this.flash.hasOwnProperty('vjs_getProperty') ? this.flash.vjs_getProperty('readyState') : 0;
  }

  /**
   * 获取视频源地址
   * flash对外部设的地址返回null不用内部方法
   */
  getSrc() {
    return this._store.getKV(KV.URL);
  }

  /**
   * 获取音量
   */
  getVolume() {
    return this._volume;
  }

  /**
   * 改变音量
   */
  setVolume(vol) {
    if (this.flash.hasOwnProperty('vjs_setProperty')) {
      vol = +vol;
      if (vol > 1 || vol < 0) {
        log.warn(`volume value range should be between 0 to 1, now you set ${vol}`);
        vol = Math.min(Math.max(0, vol), 1);
      }
      if (this._volume !== vol) {
        this._volume = vol;
        this.flash.vjs_setProperty('volume', vol);
      }
      this.flash.vjs_setProperty('muted', vol === 0);
    }
  }

  /**
   * 获取当前seek状态，是否跳转中
   */
  getSeeking() {
    return this.flash.vjs_getProperty('seeking');
  }

  /**
   * 获取cdn
   * flash不播时移
   */
  getCdnName() {
    return null;
  }

  /**
   * 设置倍速
   * flash不支持倍速功能（defaultPlaybackRate = 1）
   */
  setPlaybackRate(v) {}
}
